import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getproductpackingstructure,
  saveproductpackingstructure,
  deletepackingdata,
} from "../../../apiservice/inventory";

// 🔹 Transform API response (compatible with both shapes)
const transformPackingDataApiData = (apiResponse) => {
  if (!apiResponse || !apiResponse?.data) return [];

  const list = Array.isArray(apiResponse.data)
    ? apiResponse.data
    : apiResponse.data?.data;

  if (!list) return [];

  return list.map((item) => ({
    id: item.id,   // packing row id from backend
    item_id: item.product_id,
    itemName: item.item_name || "",
    retailRate: item.sale_rate || 0,

    stdPackName: item.std_pack_name || "",
    stdPackQty: item.std_pack_qty || 0,
    stdRate: item.std_rate ? Number(item.std_rate).toFixed(2) : "0.00",

    secondPackName: item.second_pack_name || "",
    secondPackQty: item.second_pack_qty || 0,
    secondRate: item.second_rate ? Number(item.second_rate).toFixed(2) : "0.00",

    thirdPackName: item.third_pack_name || "",
    thirdPackQty: item.third_pack_qty || 0,
    thirdRate: item.third_rate ? Number(item.third_rate).toFixed(2) : "0.00",

    fourthPackName: item.fourth_pack_name || "",
    fourthPackQty: item.fourth_pack_qty || 0,
    fourthRate: item.fourth_rate ? Number(item.fourth_rate).toFixed(2) : "0.00",

    fifthPackName: item.fifth_pack_name || "",
    fifthPackQty: item.fifth_pack_qty || 0,
    fifthRate: item.fifth_rate ? Number(item.fifth_rate).toFixed(2) : "0.00",

    sixthPackName: item.sixth_pack_name || "",
    sixthPackQty: item.sixth_pack_qty || 0,
    sixthRate: item.sixth_rate ? Number(item.sixth_rate).toFixed(2) : "0.00",
  }));
};

// 🔹 Fetch list
export const fetchPackingList = createAsyncThunk(
  "packing/fetchPackingList",
  async (_, thunkAPI) => {
    try {
      const res = await getproductpackingstructure();
      return transformPackingDataApiData(res);
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch packing list");
    }
  }
);

// 🔹 Save
export const savePacking = createAsyncThunk(
  "packing/savePacking",
  async (payload, thunkAPI) => {
   try {
      const res = await saveproductpackingstructure({
        ...payload,
        action: payload.id ? "update" : "create",
      });

      if (res.data?.error) {
        return thunkAPI.rejectWithValue(res.data.msg || "Save failed");
      }

      thunkAPI.dispatch(fetchPackingList()); // refresh list
      return res.data.msg;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err?.response?.data?.message || "Failed to save packing structure"
      );
    }
  }
);

// 🔹 Delete
// export const deletePacking = createAsyncThunk(
//   "packing/deletePacking",
//   async (productId, thunkAPI) => {
//     try {
//       const res = await deletepackingdata({ product_id: productId });
// console.log('res::::::',res.data)
//       if (res.data?.error) {
//         return thunkAPI.rejectWithValue(res.data.msg || "Delete failed");
//       }

//       thunkAPI.dispatch(fetchPackingList()); // refresh list
//       return res.data.msg;
//     } catch (err) {
//       return thunkAPI.rejectWithValue(
//         err?.response?.data?.message || "Failed to delete packing"
//       );
//     }
//   }
// );
export const deletePacking = createAsyncThunk(
  "packing/deletePacking",
  async (productId, thunkAPI) => {
    try {
      const res = await deletepackingdata({ product_id: productId });

      const msg = res.data?.msg || "";

      // treat success message as success even if error=true
      if (res.data?.error && !msg.toLowerCase().includes("success")) {
        return thunkAPI.rejectWithValue(msg || "Delete failed");
      }

      thunkAPI.dispatch(fetchPackingList());
      return msg || "Deleted successfully";
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err?.response?.data?.message || "Failed to delete packing"
      );
    }
  }
);

